<template>
  <div>
    <v-data-table
      :loading="loading"
      :headers="headers"
      :items="items"
      :server-items-length="meta.total"
      :footer-props="footerProps"
      :options="options"
      :page="page"
      :items-per-page="itemsPerPage"
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      :multi-sort="multiSort"
      v-on="listeners"
    >
      <template v-slot:item.price="{ item }">
        {{ item.price | priceFormat }}
      </template>

      <template v-slot:item.mass_market="{ item }">
        <v-checkbox v-model="item.mass_market" disabled></v-checkbox>
      </template>

      <template v-slot:item.action="{ item }">
        <action-slot-component
          :item="item"
          route-name="booking-resources.show"
          :route-params="{ id: item.id }"
          @show="$emit('show', item)"
        />
      </template>

      <template v-slot:item.building_complex_name="{ item }">
        <span class="mr-2">{{ item.building_complex_name }}</span>
        <router-link
          v-if="item.building_complex_id"
          class="text-decoration-none"
          target="_blank"
          :to="{
            name: 'building_complexes.show',
            params: { id: item.building_complex_id }
          }"
        >
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon small v-on="on">
                mdi-eye-outline
              </v-icon>
            </template>
            <span v-if="item.building_complex_name">{{
              item.building_complex_name
            }}</span>
            <span v-else>{{ $t('ITEM.VIEW') }}</span>
          </v-tooltip>
        </router-link>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { priceFormat } from '@/modules/_global/filters';
import i18nRefreshData from '@/modules/_global/mixins/i18nRefreshData';
import listItems from '@/modules/_global/mixins/list-items';
import ActionSlotComponent from '@/modules/_global/_components/ActionSlotComponent.vue';

export default {
  name: 'ExpensesList',
  components: { ActionSlotComponent },

  filters: { priceFormat },

  mixins: [i18nRefreshData, listItems],

  computed: {
    headers() {
      return [
        {
          text: this.$t('ITEM.ID'),
          align: 'left',
          sortable: true,
          value: 'id'
        },
        {
          text: this.$t('BOOKING.RESOURCES.ITEM'),
          sortable: true,
          value: 'title'
        },
        {
          text: this.$t('BUILDING_COMPLEXES.ITEM'),
          sortable: true,
          value: 'building_complex_name'
        },
        {
          text: this.$t('BUILDINGS.ITEM'),
          sortable: true,
          value: 'building_street'
        },
        {
          text: this.$t('ITEM.PRICE'),
          sortable: true,
          value: 'price',
          align: 'right'
        },
        {
          text: this.$t('ITEM.TYPE'),
          sortable: true,
          value: 'type'
        },
        {
          text: this.$t('BOOKING.RESOURCES.MASS_MARKET'),
          sortable: true,
          value: 'mass_market'
        },
        {
          text: this.$t('ITEM.STATUS'),
          sortable: true,
          value: 'status'
        },
        {
          text: this.$t('DATA_TABLE.ACTIONS'),
          value: 'action',
          sortable: false,
          align: 'center'
        }
      ];
    }
  }
};
</script>
